import LoginPage from "../pages/LoginPage/LoginPage";
import AuthCallback from "../pages/LoginPage/AuthCallback";
import RegisterPage from "../pages/LoginPage/RegisterPage";
import ConfirmEmail from "../pages/LoginPage/ConfirmEmail";
import ResetPwd from "../pages/ResetPwd/ResetPwd";
import ConfirmPwd from "../pages/ResetPwd/ConfirmPwd";
import PageLayout from "../pages/PageLayout";
import ProfileBuilder from "../pages/main/ProfileBuilder/ProfileBuilder";
import ProfileEditor from "../pages/main/ProfileBuilder/ProfileEditor";
import ShareCoach from "../pages/main/ProfileBuilder/ShareCoach";
import ContentManager from "../pages/main/ContentManager/ContentManager";
import SubscriberManager from "../pages/main/SubscriberManager";
import CoachManager from "../pages/main/CoachManager";
import CreatePractice from "../pages/main/CreatePractice/CreatePractice";
import CreateQuote from "../pages/main/CreateQuote/CreateQuote";
import CreatePrompt from "../pages/main/CreatePrompt/CreatePrompt";
import CreateChallenge from "../pages/main/CreateChallenge/CreateChallenge";
import CreateLink from "../pages/main/CreateChallenge/CreateLink";
import ShareChallenge from "../pages/main/CreateChallenge/ShareChallenge";
import CreateAction from "../pages/main/CreateAction/CreateAction";
import AiPrompt from "../pages/main/AiPrompt/AiPrompt";
import AiChallenge from "../pages/main/AiChallenge/AiChallenge";
import Page404 from "../pages/Page404";
import PricingPage from "../pages/main/ManageBilling/PricingPage";
import SubscriptionSuccess from "../pages/main/ManageBilling/SubscriptionSuccess";
import SubscriptionCancel from "../pages/main/ManageBilling/SubscriptionCancel";
import AccountSettings from "../pages/main/ManageBilling/AccountSettings";

const requireAuth = (flag, elem) => {
  return flag ? elem : <LoginPage />;
};

const routes = (isLoggedIn) => [
  {
    path: "/Login",
    element: <LoginPage />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/Register",
    element: <RegisterPage />,
  },
  {
    path: "/ResetPwd",
    element: <ResetPwd />,
  },
  {
    path: "/confirm",
    element: <ConfirmEmail />,
  },
  {
    path: "/confirm-reset-password",
    element: <ConfirmPwd />,
  },
  {
    path: "/ShareChallenge",
    element: <ShareChallenge />,
  },
  {
    path: "/ShareCoach",
    element: <ShareCoach />,
  },
  {
    path: "/",
    element: requireAuth(isLoggedIn, <PageLayout />),
    children: [
      {
        index: true,
        element: <ContentManager />,
      },
      {
        index: true,
        path: "/ContentManager",
        element: <ContentManager />,
      },
      {
        path: "/SubscriberManager",
        element: <SubscriberManager />,
      },
      {
        path: "/CreatePractice",
        element: <CreatePractice />,
      },
      {
        path: "/EditPractice",
        element: <CreatePractice />,
      },
      {
        path: "/CreateQuote",
        element: <CreateQuote />,
      },
      {
        path: "/EditQuote",
        element: <CreateQuote />,
      },
      {
        path: "/CreatePrompt",
        element: <CreatePrompt />,
      },
      {
        path: "/EditPrompt",
        element: <CreatePrompt />,
      },
      {
        path: "/CreateChallenge",
        element: <CreateChallenge />,
      },
      {
        path: "/EditChallenge",
        element: <CreateChallenge />,
      },
      {
        path: "/DuplicateChallenge",
        element: <CreateChallenge />,
      },
      {
        path: "/AiPrompt",
        element: <AiPrompt />,
      },
      {
        path: "/AiChallenge",
        element: <AiChallenge />,
      },
      {
        path: "/CreateLink",
        element: <CreateLink />,
      },
      {
        path: "/CreateAction",
        element: <CreateAction />,
      },
      {
        path: "/EditAction",
        element: <CreateAction />,
      },
      {
        path: "/ProfileBuilder",
        element: <ProfileBuilder />,
      },
      {
        path: "/ProfileBuilder/Edit",
        element: <ProfileEditor />,
      },
      {
        path: "/pricing",
        element: <PricingPage />,
      },
      {
        path: "/portal/subscribe",
        element: <PricingPage />,
      },
      {
        path: "/payment/success",
        element: <SubscriptionSuccess />,
      },
      {
        path: "/payment/cancel",
        element: <SubscriptionCancel />,
      },
      {
        path: "/AccountSettings",
        element: <AccountSettings />,
      },
      {
        path: "/CoachManager",
        element: <CoachManager />,
      },
    ],
  },
  {
    path: "*",
    element: <Page404 />,
  },
];

export { routes };
